import { ProjectActivityDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as ProjectActivityActions from './project-activity.actions';

export const PROJECT_ACTIVITY_FEATURE_KEY = 'projectActivity';

export interface ProjectActivityState extends EntityState<ProjectActivityDto> {
  selectedProjectActivityId?: string | number; // which ProjectActivity record has been selected
  loaded: boolean; // has the ProjectActivity list been loaded
  error?: string | null; // last none error (if any)
}

export interface ProjectActivityPartialState {
  readonly [PROJECT_ACTIVITY_FEATURE_KEY]: ProjectActivityState;
}

export const projectActivityAdapter: EntityAdapter<ProjectActivityDto> = createEntityAdapter<
  ProjectActivityDto
>({
  selectId: (projectActivity) => projectActivity.id,
  sortComparer: false,
});

export const initialState: ProjectActivityState = projectActivityAdapter.getInitialState(
  {
    // set initial required properties
    loaded: false,
    error: null,
    selectedProjectActivityId: null,
  }
);

const projectActivityReducer = createReducer(
  initialState,
  on(ProjectActivityActions.loadProjectActivity, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectActivityActions.loadProjectActivitySuccess,
    (state, { projectActivity }) =>
      projectActivityAdapter.addAll(projectActivity, {
        ...state,
        loaded: false,
      })
  ),
  on(ProjectActivityActions.loadProjectActivityFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(ProjectActivityActions.addProjectActivity, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectActivityActions.addProjectActivitySuccess,
    (state, { newProjectActivity }) =>
      projectActivityAdapter.addMany(newProjectActivity, {
        ...state,
        loaded: false,
      })
  ),
  on(ProjectActivityActions.addProjectActivityFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),

  on(ProjectActivityActions.updateProjectActivity, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectActivityActions.updateProjectActivitySuccess,
    (state, { updateProjectActivity }) =>
      projectActivityAdapter.upsertMany(updateProjectActivity, {
        ...state,
        loaded: false,
      })
  ),
  on(
    ProjectActivityActions.updateProjectActivityFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  ),
  // search student

  on(ProjectActivityActions.searchProjectActivityRecord, (state, { query }) => {
    return {
      ...state,
      selectedProjectActivityId: query,
      loaded: false,
      error: null,
    };
  }),
  on(ProjectActivityActions.removeProjectActivity, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(ProjectActivityActions.removeProjectActivitySuccess, (state, { ids }) =>
    projectActivityAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(
    ProjectActivityActions.removeProjectActivityFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  )
);

export function reducer(
  state: ProjectActivityState | undefined,
  action: Action
) {
  return projectActivityReducer(state, action);
}
